<template>
  <div class="esm-item-form">
    <form>
      <text-select-input
        v-model="val.item"
        @input="updateFinding($event)"
        :options="{
          label: 'Item',
          name: 'item',
          existing,
          value: val.item || '',
          allowEdit: true
        }">
      </text-select-input>
      <text-input
        v-model="val.companyName"
        :options="{
          label: 'Company Name',
          name: 'companyName',
          value: val.companyName
        }">
      </text-input>
      <address-input
        v-model="val.address"
        :options="{
          label: 'Address',
          name: 'address',
          value: val.address,
          existing: val.address ? [{ value: val.address, label: val.address }] : [],
        }">
      </address-input>
      <radio-input
        v-model="val.status"
        :options="{
          name: 'status',
          label: 'Status',
          radios: radios.STATUS,
          value: val.status,
          inline: true,
          index
        }">
      </radio-input>
      <calendar-input
        v-model="val.lastTested"
        :options="{
          name: 'lastTested',
          label: 'Last Tested Date',
          value: val.lastTested
        }">
      </calendar-input>
      <rich-text-input
        ref="finding"
        v-model="val.finding"
        :options="{
          label: 'Finding',
          name: 'finding',
          value: val.finding,
          height: 150,
          index: val.added
        }">
      </rich-text-input>
    </form>
  </div>
</template>

<script>
  import Api from '@/vuex/api'
  import {
    STATUS
  } from '@/ESMItems'
  import TextSelectInput from '@/components/inputs/TextSelectInput'
  import TextInput from '@/components/inputs/TextInput'
  import AddressInput from '@/components/inputs/AddressInput'
  import RadioInput from '@/components/inputs/RadioInput'
  import CalendarInput from '@/components/inputs/CalendarInput'
  import RichTextInput from '@/components/inputs/RichTextInput'
  export default {
    name: 'EsmItemForm',
    components: {
      AddressInput,
      CalendarInput,
      RadioInput,
      RichTextInput,
      TextSelectInput,
      TextInput
    },
    data () {
      return {
        radios: {
          STATUS
        },
        update: false,
        uuidRegex: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-4][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i
      }
    },
    props: {
      val: {
        type: Object
      },
      index: {
        type: Number
      },
      existing: {
        type: Array
      }
    },
    methods: {
      async updateFinding (val) {
        if (this.isUuid(val) && this.update) {
          let instance = new Api()
          let finding = await instance.getFinding(val)
          this.$refs.finding.updateContent(finding)
        }
        this.update = true
      },
      isUuid (uuid) {
        if (!uuid) return false
        uuid = uuid.toLowerCase()
        return this.uuidRegex.test(uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/displays/EsmItemForm.vue